export let dataProps = {
    id: 0,
    category_name: '',
    remarks: '',
    active: true
}


// WEBPACK FOOTER //
// ./src/store/modules/eStoreCategory/properties.js